import { TabletCloseLandscapeParams } from "../types/index-type";
import { initQueryselectorTablet } from "./init-queryselector-tablet";



const isHTMLElement = (element: Element | null): element is HTMLElement =>
  element instanceof HTMLElement;

export const initTabletCloseLandscape = ({
  wholeLeftPositionCloseLandscape,
  sidebarColumnsLandscape,
  mainColumnsFillwidth,
}: TabletCloseLandscapeParams) => {
  const selectors = initQueryselectorTablet();
  const { body, grid, sideBarButton, codeArticle } = selectors;

  if (isHTMLElement(grid)) {
    grid.style.left = `${wholeLeftPositionCloseLandscape}vw`;
    grid.style.gridTemplateColumns = `${sidebarColumnsLandscape}vw ${mainColumnsFillwidth}vw`;
  }

  codeArticle.forEach((article) => {
    article.style.width = "100%";
  });

  body?.classList.remove("sidebar-open");
  body?.classList.add("sidebar-closed");

  if (isHTMLElement(sideBarButton)) {
    sideBarButton.textContent = "OPEN";
  }

  return selectors;
};
